import { render } from "./CoinFav.vue?vue&type=template&id=13c86aea&scoped=true"
import script from "./CoinFav.vue?vue&type=script&lang=js"
export * from "./CoinFav.vue?vue&type=script&lang=js"

import "./CoinFav.vue?vue&type=style&index=0&id=13c86aea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c86aea"]])

export default __exports__